<mnf-dashboard-v2-submenu-graphs [profitUser]="profitUser"></mnf-dashboard-v2-submenu-graphs>